import React, { useState, useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitPatient, { Search } from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as actions from "../../_redux/patientsActions";
import * as Yup from "yup";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import * as uiHelpers from "./PatientAppointmentsUIHelpers";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "../column-formatters";
// import * as patients from "../../Patients";
import {
  PatientAppointmentsUIPatient,
  usePatientAppointmentsUIContext,
} from "./PatientAppointmentsUIContext";
import { usePatientsUIContext } from "../../PatientsUIContext";

function PatientAppointments({ history }) {
  const PatientAppointmentsUIEvents = {
    openDetailPatientAppointmentsPage: (id) => {
      history.push(`/patients/${id}/appointments`);
    },
  };

  const patientAppointmentsUIContext = usePatientAppointmentsUIContext();

  const patientAppointmentsUIProps = useMemo(() => {
    return {
      ids: patientAppointmentsUIContext.ids,
      setIds: patientAppointmentsUIContext.setIds,
      queryParams: patientAppointmentsUIContext.queryParams,
      setQueryParams: patientAppointmentsUIContext.setQueryParams,
      openDetailPatientAppointmentTransactionPage:
        patientAppointmentsUIContext.openDetailPatientAppointmentTransactionPage,
    };
  }, [patientAppointmentsUIContext]);

  // Fields
  const [loading, setloading] = useState(false);
  const [pic, setPic] = useState("");
  const dispatch = useDispatch();
  const currentState = useSelector(
    (state) => state.patients.appointments,
    shallowEqual
  );
  const patient = useSelector((state) => state.patients.patient, shallowEqual);

  useEffect(() => {
    // clear selections list
    patientAppointmentsUIProps.setIds([]);

    dispatch(
      actions.fetchPatientAppointments(patient.id, patientAppointmentsUIProps)
    );
  }, [patientAppointmentsUIProps.queryParams, dispatch]);
  // Methods

  const { totalCount, entities, listLoading } = currentState;

  // Table columns
  const columns = [
    {
      dataField: "user.username",
      text: "Provider",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.ProviderProfilePictureColumnFormatter,
    },
    {
      dataField: "uuid",
      text: "Reciept ID",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "appointment_type.name",
      text: "Type",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.AppointmentTypeColumnFormatter,
      sortCaret: sortCaret,
    },

    {
      dataField: "type",
      text: "Channel",
      sort: true,
      sortCaret: sortCaret,
    },

    {
      dataField: "status",
      text: "Status",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.AppointmentStatusColumnFormatter,
      headerSortingClasses,
    },
    {
      dataField: "session_start_time",
      text: "Date",
      sort: true,
      sortCaret: sortCaret,
    },
    // {
    //   dataField: "action",
    //   text: "Actions",
    //   formatter: columnFormatters.ActionsColumnFormatter,
    //   formatExtraData: {
    //     openDetailImmunizationPage: patientAppointmentsUIProps.openDetailImmunizationPage,
    //     openEditProductPage: patientAppointmentsUIProps.openEditProductPage,
    //     openDeleteProductDialog: patientAppointmentsUIProps.openDeleteProductDialog,
    //   },
    //   classes: "text-right pr-0",
    //   headerClasses: "text-right pr-3",
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: patientAppointmentsUIProps.queryParams.pageSize,
    page: patientAppointmentsUIProps.queryParams.pageNumber,
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      // patientAppointmentsUIProps.openDetailPatientPage(row?.id)
    },
  };

  return (
    <>
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">
            Appointments
          </h3>
          <span className="text-muted font-weight-bold font-size-sm mt-1">
            List of patient appointments
          </span>
        </div>
      </div>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  patientAppointmentsUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: patientAppointmentsUIProps.ids,
                  setIds: patientAppointmentsUIProps.setIds,
                })}
                rowEvents={rowEvents}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}

// export default connect(null, patients.actions)(PatientPersonaInformation);
export default PatientAppointments;
